import React from 'react';

import { ToastProps } from '../Toast';

export type ToastStatus = 'success' | 'error' | 'warning' | 'info';

export type StatusToastProps = Omit<ToastProps, 'role'> & {
  /** Toast status. */
  status?: ToastStatus;
  /** Action element to render. */
  action?: React.ReactNode;
  /** Number in milliseconds to auto dismiss the toast. If the duration is set to 'null', toast won't be automatically dismissed. */
  duration?: number | null;
};
